<div class="prs-auth-modal-panel" data-testing-id="request-access-modal">
  <div class="modal-header">
    <h2 class="modal-title" id="prs-auth-modal-request-access-title">
      {{
        (submitted ? message || 'account.request_access.success' : 'account.request_access.heading') | translate
      }}
    </h2>
    <button
      type="button"
      class="btn-close"
      [attr.title]="'dialog.close.text' | translate"
      [attr.aria-label]="'dialog.close.text' | translate"
      (click)="hide()"
    ></button>
  </div>

  <div class="modal-body">
    @if (!submitted) {
    <p class="text-muted mb-3">
      {{
        (step === 'erp' ? 'account.request_access.lead.erp' : 'account.request_access.lead.details') | translate
      }}
    </p>
    }

    @if (error) {
    <div
      class="alert alert-danger"
      role="alert"
      [attr.data-testing-id]="
        emailAlreadyExists
          ? 'request-access-email-exists'
          : emailDomainRejected
            ? 'request-access-email-domain'
            : contactSalesRep
              ? 'request-access-contact-sales'
              : null
      "
    >
      @if (emailAlreadyExists) {
      <span>{{ 'account.request_access.error.email_exists.before' | translate }}</span>
      <button
        type="button"
        class="btn btn-link alert-link p-0 align-baseline"
        data-testing-id="request-access-reset-password"
        (click)="openForgotPassword()"
      >
        {{ 'account.request_access.error.email_exists.reset_link' | translate }}
      </button>
      <span>{{ 'account.request_access.error.email_exists.after' | translate }}</span>
      } @else {
      {{ error | translate }}
      }
    </div>
    }

    @if (!submitted) {
    <form
      id="prs-request-access-form"
      class="prs-auth-request-form"
      [formGroup]="form"
      (ngSubmit)="submit()"
      novalidate
    >
      <div class="prs-auth-field-grid">
        <div
          class="form-group prs-auth-field--full"
          [class.has-error]="invalid('erpCustomerNo')"
          (click)="onErpFieldActivate($event)"
        >
          <label class="form-label" for="erpCustomerNo">{{ 'account.request_access.erp.label' | translate }}</label>
          <div class="prs-auth-input-wrap position-relative">
            <input
              id="erpCustomerNo"
              class="form-control"
              formControlName="erpCustomerNo"
              autocomplete="organization"
              [attr.aria-invalid]="invalid('erpCustomerNo') ? true : null"
              [attr.aria-describedby]="
                invalid('erpCustomerNo')
                  ? 'erpCustomerNo-error'
                  : step === 'erp'
                    ? 'erpCustomerNo-demo-hint'
                    : null
              "
              [attr.title]="step === 'erp' ? ('account.request_access.demo.field_hint' | translate) : null"
            />
            <ish-auth-field-validation-icons
              [showError]="invalid('erpCustomerNo')"
              [showSuccess]="showValid('erpCustomerNo')"
            />
          </div>
          @if (step === 'erp') {
          <div id="erpCustomerNo-demo-hint" class="form-text" data-testing-id="request-access-demo-hint">
            {{ 'account.request_access.demo.field_hint' | translate }}
          </div>
          }
          @if (invalid('erpCustomerNo')) {
          <div id="erpCustomerNo-error" class="invalid-feedback d-block" role="alert">
            {{ 'account.request_access.erp.error.required' | translate }}
          </div>
          }
          @if (step === 'details' && verifiedCompanyName) {
          <div class="form-text" role="status" data-testing-id="request-access-verified-account">
            {{ 'account.request_access.erp.verified' | translate: { '0': verifiedCompanyName } }}
          </div>
          }
        </div>

        @if (step === 'details') {
        <div class="form-group" [class.has-error]="invalid('firstName')">
          <label class="form-label" for="firstName">{{ 'account.address.firstname.label' | translate }}</label>
          <div class="prs-auth-input-wrap position-relative">
            <input
              id="firstName"
              class="form-control"
              formControlName="firstName"
              autocomplete="given-name"
              [attr.aria-invalid]="invalid('firstName') ? true : null"
              [attr.aria-describedby]="invalid('firstName') ? 'firstName-error' : null"
            />
            <ish-auth-field-validation-icons
              [showError]="invalid('firstName')"
              [showSuccess]="showValid('firstName')"
            />
          </div>
          @if (invalid('firstName')) {
          <div id="firstName-error" class="invalid-feedback d-block" role="alert">
            {{ nameErrorKey('firstName') | translate }}
          </div>
          }
        </div>
        <div class="form-group" [class.has-error]="invalid('lastName')">
          <label class="form-label" for="lastName">{{ 'account.address.lastname.label' | translate }}</label>
          <div class="prs-auth-input-wrap position-relative">
            <input
              id="lastName"
              class="form-control"
              formControlName="lastName"
              autocomplete="family-name"
              [attr.aria-invalid]="invalid('lastName') ? true : null"
              [attr.aria-describedby]="invalid('lastName') ? 'lastName-error' : null"
            />
            <ish-auth-field-validation-icons
              [showError]="invalid('lastName')"
              [showSuccess]="showValid('lastName')"
            />
          </div>
          @if (invalid('lastName')) {
          <div id="lastName-error" class="invalid-feedback d-block" role="alert">
            {{ nameErrorKey('lastName') | translate }}
          </div>
          }
        </div>
        <div class="form-group prs-auth-field--full" [class.has-error]="invalid('email')">
          <label class="form-label" for="email">{{ 'account.register.email.label' | translate }}</label>
          <div class="prs-auth-input-wrap position-relative">
            <input
              id="email"
              type="email"
              class="form-control"
              formControlName="email"
              autocomplete="email"
              [attr.aria-invalid]="invalid('email') ? true : null"
              [attr.aria-describedby]="invalid('email') ? 'email-error' : null"
            />
            <ish-auth-field-validation-icons [showError]="invalid('email')" [showSuccess]="showValid('email')" />
          </div>
          @if (invalid('email')) {
          <div id="email-error" class="invalid-feedback d-block" role="alert">
            @if (form.controls.email.errors?.required) {
            {{ 'form.email.error.required' | translate }}
            } @else if (form.controls.email.errors?.emailDomain) {
            {{ 'account.request_access.error.email_domain' | translate }}
            } @else {
            {{ 'form.email.error.invalid' | translate }}
            }
          </div>
          }
        </div>
        <div class="form-group" [class.has-error]="invalid('password')">
          <div class="prs-auth-input-wrap position-relative">
            <prs-password-input
              inputId="password"
              testingId="password"
              labelKey="account.register.password.label"
              autocomplete="new-password"
              ariaDescribedBy="request-access-password-help"
              [control]="form.controls.password"
              [ariaInvalid]="invalid('password') ? true : null"
            />
            <ish-auth-field-validation-icons
              [showError]="invalid('password')"
              [showSuccess]="showValid('password')"
            />
          </div>
          @if (invalid('password') && form.controls.password.errors?.required) {
          <div class="invalid-feedback d-block" role="alert">
            {{ 'form.password.error.required' | translate }}
          </div>
          }
        </div>
        <div class="form-group" [class.has-error]="invalid('passwordConfirmation')">
          <div class="prs-auth-input-wrap position-relative">
            <prs-password-input
              inputId="passwordConfirmation"
              testingId="passwordConfirmation"
              labelKey="account.register.password_confirmation.label"
              autocomplete="new-password"
              [control]="form.controls.passwordConfirmation"
              [ariaInvalid]="invalid('passwordConfirmation') ? true : null"
            />
            <ish-auth-field-validation-icons
              [showError]="invalid('passwordConfirmation')"
              [showSuccess]="showValid('passwordConfirmation')"
            />
          </div>
          @if (invalid('passwordConfirmation')) {
          <div class="invalid-feedback d-block" role="alert">
            @if (form.controls.passwordConfirmation.errors?.required) {
            {{ 'account.register.password_confirmation.error.default' | translate }}
            } @else if (form.controls.passwordConfirmation.errors?.equalTo) {
            {{ 'form.password.error.equalTo' | translate }}
            }
          </div>
          }
        </div>
        <div id="request-access-password-help" class="prs-auth-password-hint prs-auth-field--full">
          <prs-password-requirements [value]="form.controls.password.value" />
        </div>
        }
      </div>
    </form>
    } @else {
    <div class="prs-access-pending" data-testing-id="request-access-pending" role="status">
      <p class="fw-semibold mb-2">{{ 'account.request_access.success.pending.heading' | translate }}</p>
      @if (routeOutcome === 'sales') {
      <p class="text-muted mb-2">{{ 'account.request_access.success.sales.pending' | translate }}</p>
      } @else {
      <p class="text-muted mb-2">{{ 'account.request_access.success.admin.pending' | translate }}</p>
      }
      <p class="small text-muted mb-0">{{ 'account.request_access.success.pending.no_access' | translate }}</p>
    </div>
    }
  </div>

  <div class="modal-footer prs-auth-modal-footer">
    @if (!submitted) {
    @if (step === 'erp') {
    <button
      class="btn btn-primary"
      type="submit"
      form="prs-request-access-form"
      data-testing-id="request-access-verify"
      [disabled]="verifyErpDisabled"
    >
      {{ 'account.request_access.erp.verify' | translate }}
    </button>
    } @else {
    <button
      class="btn btn-primary"
      type="submit"
      form="prs-request-access-form"
      data-testing-id="request-access-submit"
      [disabled]="submitting"
    >
      {{ 'account.request_access.submit' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-link"
      data-testing-id="request-access-change-erp"
      (click)="changeErp()"
      [disabled]="submitting"
    >
      {{ 'account.request_access.erp.change' | translate }}
    </button>
    }
    <button type="button" class="btn btn-link" data-testing-id="request-access-cancel" (click)="hide()">
      {{ 'account.request_access.cancel' | translate }}
    </button>
    } @else {
    <button type="button" class="btn btn-primary" data-testing-id="request-access-close" (click)="hide()">
      {{ 'dialog.close.text' | translate }}
    </button>
    }
  </div>
</div>
